import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fce8f252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  select: "",
  value: null
}, "No preview argument", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code static" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye static right hover-icon" })
], -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "display-select"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Views", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = {
  key: 0,
  class: "display-select"
}
const _hoisted_18 = { class: "title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Spread", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "bottom" }
const _hoisted_33 = { class: "field has-addons header-field spinner" }
const _hoisted_34 = {
  key: 0,
  class: "fas fa-spinner"
}
const _hoisted_35 = { class: "field has-addons header-field" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "field has-addons header-field col" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "fas fa-play-circle"
}
const _hoisted_42 = {
  key: 1,
  class: "fas fa-stop-circle"
}
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "field has-addons header-field" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "field has-addons header-field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { overflow: "visible" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["preview", { display: _ctx.displayPreviewSelector }]),
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDisplayPreviewSelector(true))),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDisplayPreviewSelector(false)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass([{ on: _ctx.lockPreview }, "fas fa-lock small lock"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLockPreview(!_ctx.lockPreview)))
          }, null, 2),
          _withDirectives(_createElementVNode("select", {
            class: "select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalPickedPreviewArgument) = $event))
          }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.data.previewArguments, (previewArgument, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: previewArgument
              }, _toDisplayString(previewArgument.name), 9, _hoisted_3))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.internalPickedPreviewArgument]
          ]),
          _hoisted_4
        ], 34),
        (_ctx.currentPackage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["view-bar", { display: _ctx.displayView }]),
              onMouseover: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDisplayView(true))),
              onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setDisplayView(false)))
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_ctx.currentPackage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", {
                          class: "add dark right border-l",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addView()))
                        }, _hoisted_11)
                      ]),
                      _createElementVNode("div", {
                        disabled: "",
                        class: "option",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentViewKey = null))
                      }, "~ No view ~"),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPackage.data.views, (view, viewKey) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["option", { selected: _ctx.currentViewKey === viewKey }]),
                          key: viewKey,
                          onClick: ($event: any) => (_ctx.currentViewKey = viewKey)
                        }, [
                          _createElementVNode("div", null, _toDisplayString(viewKey), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "button is-small red",
                              onClick: ($event: any) => (_ctx.removeView(viewKey))
                            }, _hoisted_15, 8, _hoisted_13)
                          ])
                        ], 10, _hoisted_12))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.currentViewKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", {
                          class: "add dark right border-l",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addSpread()))
                        }, _hoisted_21)
                      ]),
                      _createElementVNode("div", {
                        disabled: "",
                        class: "option",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentSpread = null))
                      }, "~ No view ~"),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentView.spreads, (spread, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "option",
                          key: i
                        }, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (_ctx.currentSpread = spread),
                            class: _normalizeClass(["optionName", { selected: _ctx.currentSpread === spread }])
                          }, _toDisplayString(spread?.name), 11, _hoisted_22),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "button is-small",
                              onClick: ($event: any) => (_ctx.downSpread(i)),
                              disabled: i<=0
                            }, _hoisted_25, 8, _hoisted_23),
                            _createElementVNode("button", {
                              class: "button is-small",
                              onClick: ($event: any) => (_ctx.upSpread(i)),
                              disabled: i>=_ctx.currentView.spreads.length-1
                            }, _hoisted_28, 8, _hoisted_26),
                            _createElementVNode("button", {
                              class: "button is-small red",
                              onClick: ($event: any) => (_ctx.removeSpread(i))
                            }, _hoisted_31, 8, _hoisted_29)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 34))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (_ctx.rendering)
              ? (_openBlock(), _createElementBlock("i", _hoisted_34))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            (!_ctx.live)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button is-small is-primary play-button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.play())),
                  disabled: !_ctx.currentSpread
                }, _hoisted_38, 8, _hoisted_36))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-small is-primary", {green: _ctx.live}]),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleLive())),
              disabled: !_ctx.currentSpread
            }, [
              (!_ctx.live)
                ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                : (_openBlock(), _createElementBlock("i", _hoisted_42))
            ], 10, _hoisted_40),
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass([{hidden:!_ctx.live}, "select is-small"]),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.internalLiveInterval) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([500, 1000, 2000, 5000, 10000], (liveInterval, i) => {
                return _createElementVNode("option", {
                  key: i,
                  value: liveInterval
                }, _toDisplayString(liveInterval / 1000) + "s ", 9, _hoisted_43)
              }), 64))
            ], 2), [
              [_vModelSelect, _ctx.internalLiveInterval]
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              class: "button is-small is-primary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.save())),
              disabled: !_ctx.currentPackage
            }, _hoisted_47, 8, _hoisted_45)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              class: "button is-small is-primary red",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteProject()))
            }, _hoisted_50)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}